import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

import styled from "styled-components";
export const LatestCard = ({ LatestPost }) => {
  const { title, image, slug, excerpt } = LatestPost;
  const CardImage = getImage(image);
  return (
    <Container>
      <Link to={`/blog/${slug}`}>
        <GatsbyImage image={CardImage} alt={title} />
      </Link>

      <div className="content">
        <Title>{title}</Title>
        <Line />
        <Excerpt>{excerpt.excerpt}</Excerpt>
        <More to={`/blog/${slug}`}>Read More</More>
      </div>
    </Container>
  );
};

const Container = styled.div`
  overflow: hidden;
  border-radius: 5px;
  margin: 1rem;
  box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.25);

  @media screen and (min-width: 800px) {
    display: flex;
    margin: 1rem 3rem;
    .content {
      max-width: 30%;
    }
  }
  .content {
    padding: 1rem;
  }
  img {
    width: 100%;
  }

  a {
    text-decoration: none;
  }
  a:hover {
    opacity: 0.9;
  }
`;

const Title = styled.h3`
  color: #525050;
  @media screen and (min-width: 1050px) {
    font-size: 2rem;
  }
`;
const Excerpt = styled.p`
  color: #7d7d7d;
  @media screen and (min-width: 800px) {
    font-size: 14px;
  }
  @media screen and (min-width: 1050px) {
    font-size: 20px;
  }

  font-size: calc(16px + (20 - 16) * ((100vw - 300px) / (1600 - 300)));
  margin-bottom: 0.5rem;
`;

const Line = styled.hr`
  border: 2px solid #525050;
  width: 30px;
  margin: 0.5rem 0;
  @media screen and (min-width: 800px) {
    width: 100px;
  }
`;
const More = styled(Link)`
  color: var(--primary-color);
`;
